export var ExternalInterfaceService = {
    enabled: true,
    callback: null,
    initJS: function (callback) {
        this.callback = callback;
        // ...
    },
    registerCallback: function (functionName) {
        var _this = this;
        if (!window["flash"]) {
            window["flash"] = {};
        }
        window["flash"][functionName] = function (args) {
            _this.callback(functionName, args);
        };
    },
    unregisterCallback: function (functionName) {
        if (!window["flash"]) {
            window["flash"] = {};
        }
        delete window["flash"][functionName];
    },
    eval: function (expression) {
        return window.eval(expression);
    },
    call: function (request) {
        // ...
    },
    getId: function () { return null; }
};
